import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { OrderStatus } from '../../order-list/interface/order-list.interface';
import { OrderService } from '../../order/service/order.service';
import { OrderState } from '../../order/state/order.state';

export const draftOrderResolver: ResolveFn<boolean> = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  _router: Router = inject(Router),
  orderService: OrderService = inject(OrderService),
  orderState: OrderState = inject(OrderState)
) => {
  const orderId = _route.paramMap.get('orderId')!;

  if (orderState.orderDetail?.id == orderId) {
    if (orderState.orderDetail.orderStatus == OrderStatus.draft) return true;
    else {
      _router.navigate(['/orders', orderId], { queryParams: _route.queryParams });
      return false;
    }
  } else {
    return orderService.getOrderDetail(orderId).pipe(
      map(() => {
        if (orderState.orderDetail.orderStatus == OrderStatus.draft) return true;
        else {
          _router.navigate(['/orders', orderState.orderDetail.id], { queryParams: _route.queryParams });
          return false;
        }
      }),
      catchError(() => {
        _router.navigate(['/orders']);
        return of(false);
      })
    );
  }
};
